import { motion } from "framer-motion";

const colors = ["#1F667E", "#2B245B", "#DA4D3D", "#F7A70F", "#FAE810"];
const shapes = ["triangle-fill", "triangle-outline", "circle-fill", "circle-outline"];

const generateShapes = (count: number) =>
  Array.from({ length: count }).map((_, i) => ({
    id: i,
    color: colors[Math.floor(Math.random() * colors.length)],
    shape: shapes[Math.floor(Math.random() * shapes.length)],
    size: Math.random() * 35 + 20,
    left: Math.random() * 100,
    top: Math.random() * 100,
    duration: Math.random() * 1 + 15,
    delay: Math.random() * 1,
  }));

const shapesArray = generateShapes(100);

export default function ShapesBackground() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {shapesArray.map((shape) => {
        const base: React.CSSProperties = {
          position: "absolute",
          left: `${shape.left}%`,
          top: `${shape.top}%`,
          opacity: 1,
        };

        if (shape.shape === "triangle-fill") {
          return (
            <motion.div
              key={shape.id}
              style={{
                ...base,
                width: 0,
                height: 0,
                borderLeft: `${shape.size / 2}px solid transparent`,
                borderRight: `${shape.size / 2}px solid transparent`,
                borderBottom: `${shape.size}px solid ${shape.color}`,
              }}
              animate={{ y: [0, -40, 0], rotate: [0, 15, -15, 0] }}
              transition={{
                duration: shape.duration,
                delay: shape.delay,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />
          );
        }

        if (shape.shape === "triangle-outline") {
          const s = shape.size;
          return (
            <motion.svg
              key={shape.id}
              width={s}
              height={s}
              viewBox="0 0 100 100"
              style={{
                ...base,
                overflow: "visible",
              }}
              animate={{ y: [0, -40, 0], rotate: [0, 15, -15, 0] }}
              transition={{
                duration: shape.duration,
                delay: shape.delay,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              <polygon
                points="50,0 0,100 100,100"
                fill="none"
                stroke={shape.color}
                strokeWidth="4"
              />
            </motion.svg>
          );
        }

        if (shape.shape === "circle-fill") {
          return (
            <motion.div
              key={shape.id}
              style={{
                ...base,
                width: `${shape.size}px`,
                height: `${shape.size}px`,
                borderRadius: "50%",
                backgroundColor: shape.color,
              }}
              animate={{ y: [0, -40, 0], rotate: [0, 15, -15, 0] }}
              transition={{
                duration: shape.duration,
                delay: shape.delay,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />
          );
        }

        if (shape.shape === "circle-outline") {
          return (
            <motion.div
              key={shape.id}
              style={{
                ...base,
                width: `${shape.size}px`,
                height: `${shape.size}px`,
                borderRadius: "50%",
                border: `3px solid ${shape.color}`,
              }}
              animate={{ y: [0, -40, 0], rotate: [0, 15, -15, 0] }}
              transition={{
                duration: shape.duration,
                delay: shape.delay,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            />
          );
        }

        return null;
      })}
    </div>
  );
}